/* Renders an arbitrary a2ui component tree (a whole surface) in the isolated
 * preview frame, via the real renderer. Same singleton-store approach as
 * PreviewHost — only one stage is mounted at a time (one active section). */
import { useEffect } from "react";
import { useStore } from "./engine/store";
import { ComponentRenderer } from "./engine/components/ComponentRenderer";
import { PreviewFrame } from "./PreviewFrame";
import { CATALOG } from "../content/catalog";
import type { Catalog, Component } from "./engine/types";

export function SurfaceStage({
  components, rootId, data,
}: {
  components: Component[];
  rootId: string;
  data?: Record<string, unknown>;
}) {
  useEffect(() => {
    const s = useStore.getState();
    s.applyCatalog(CATALOG as unknown as Catalog);
    s.applySurfaceUpdate("surface-preview", components);
    s.setRootComponent(rootId);
    s.applyDataModelUpdate(data ?? {});
  }, [components, rootId, data]);

  const rid = useStore((s) => s.rootComponentId);
  return <PreviewFrame>{rid ? <ComponentRenderer id={rid} scope={null} /> : null}</PreviewFrame>;
}
